import React, { useEffect } from "react";
import Tabs from "components/UI/Tabs";
import Tab from "components/UI/Tab";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ScreenSelect from "./ScreenSelect";
import styles from "./styles.module.css";
import {deviceFloorLevel} from "config/constants";
import { getCachedItem } from "utils/localStorage";
import SettingChooseFloor from "containers/SettingChooseFloor";
import SettingChooseDevice from "containers/SettingChooseDevice";
import SettingChooseOrientation from "containers/SettingChooseOrientation";

function AdminHome({ location }) {
  const [mapLevel, setMapLevel] = React.useState(getCachedItem(deviceFloorLevel) || 1);
  // this list will change accordingly to the mapLevel

  const history = useHistory();
  const startScreenState = useSelector((state) => state.settings.startScreen);

  useEffect(() => {
    if (startScreenState && location.pathname === "/") {
      history.push("/" + startScreenState);
    }
  }, [startScreenState]);

  return (
    <>
      <div className="container mt-5">
        <Tabs>
          <Tab label="Chọn tầng">
            <SettingChooseFloor styles={styles} changeFloor={setMapLevel} mapLevel={mapLevel} />
          </Tab>
          <Tab label="Chọn vị trí thiết bị">
            <SettingChooseDevice mapLevel={mapLevel} />
          </Tab>
          <Tab label="Chọn góc xoay bản đồ">
            <SettingChooseOrientation mapLevel={mapLevel} />
          </Tab>
          <Tab label="Chọn Màn hình">
            <ScreenSelect />
          </Tab>
        </Tabs>
      </div>
    </>
  );
}

export default AdminHome;
